import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'flexyoo-employee-basket-cart-submission-confirmation-dialog',
  templateUrl: './employee-basket-cart-submission-confirmation-dialog.component.html',
  styleUrl: './employee-basket-cart-submission-confirmation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule],
})
export class EmployeeBasketCartSubmissionConfirmationDialogComponent {
  private readonly dialogRef = inject(
    MatDialogRef<EmployeeBasketCartSubmissionConfirmationDialogComponent, boolean>
  );

  protected confirm(): void {
    this.dialogRef.close(true);
  }

  protected cancel(): void {
    this.dialogRef.close(false);
  }
}
